import { mobile } from "./mobile";
import { type NavigationEventPayload } from "./types";

/**
 * Emits a navigation event to the native webview layer.
 * No-ops outside webview context or if `onNavigationEvent` is not set.
 */
export function emitWebviewNavigationEvent(
  url: string,
  type: NavigationEventPayload["type"],
  state?: unknown,
): void {
  if (!mobile.isWebview) return;

  if (!mobile.onNavigationEvent) return;

  mobile.onNavigationEvent({
    url,
    type,
    state,
    source: "react-router",
  });
}

/**
 * Delegates back navigation to the native webview layer.
 * Returns `true` if handled (webview context), `false` otherwise.
 */
export function handleWebviewBack(): boolean {
  if (!mobile.isWebview) return false;

  mobile.onGoBack();
  return true;
}
